import {
	type OrderChargeUpdateDto,
	patchOrdersOrderIdChargesChargeId,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { getOrderDetailQueryKey } from "Order/Api/Query/useOrderDetailQuery";
import { getOrderChargeListQueryKey } from "Order/Modules/Payment/Api/Query/useOrderChargeListQuery";
import { getOrderChargesSumQueryKey } from "Order/Modules/Payment/Api/Query/useOrderChargesSumQuery";
import { getOrderFeeQueryKey } from "Order/Modules/Payment/Api/Query/useOrderFeeQuery";
import { getOrderPaymentDetailQueryKey } from "Order/Modules/Payment/Api/Query/useOrderPaymentDetailQuery";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const paymentMutationsResource = Resources.base.payment.mutation;

export const useUpdateChargeMutation = (
	chargeOrderId: number,
	chargeId: number,
	viewOrderId = chargeOrderId,
) => {
	const { t } = useResource();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse((data: OrderChargeUpdateDto) =>
			patchOrdersOrderIdChargesChargeId(data, chargeOrderId, chargeId),
		),
		onError: (error) => {
			console.error(
				`${t(paymentMutationsResource.updateChargeMutationError)}:`,
				error,
			);
		},
		onSuccess: () => {
			toast.success(t(paymentMutationsResource.updateChargeMutationSuccess));
			for (const orderId of new Set([chargeOrderId, viewOrderId])) {
				queryClient.invalidateQueries({
					queryKey: getOrderChargeListQueryKey(orderId),
				});
				queryClient.invalidateQueries({
					queryKey: getOrderChargesSumQueryKey(orderId),
				});
				queryClient.invalidateQueries({
					queryKey: getOrderPaymentDetailQueryKey(orderId),
				});
				queryClient.invalidateQueries({
					queryKey: getOrderFeeQueryKey(orderId),
				});
				queryClient.invalidateQueries({
					queryKey: getOrderDetailQueryKey(orderId),
				});
			}
		},
	});
};
